import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  font-family: CircularStd-Book;
  font-size: 16px;
  color: #d8d8d8;
`;

export default ({ children }) => <Wrap> {children} </Wrap>;



// WEBPACK FOOTER //
// ./src/components/common/candidate/GroupName.js